export const instructionSet = [
  { name: 'store', operation: '!' },
  { name: 'fetch', operation: '@' },
  { name: 'push', operation: '>' },
  { name: 'pop', operation: '<' },
  { name: 'add', operation: '+' },
  { name: 'subtract', operation: '-' },
  { name: 'equals', operation: '=' },
  { name: 'and', operation: '&' },
  { name: 'or', operation: '|' },
  { name: 'drop', operation: 'V' },
  { name: 'dup', operation: 'D' },
  { name: 'over', operation: 'U' },
  { name: 'swap', operation: 'S' },
  { name: 'xor', operation: 'X' },
  { name: 'if', operation: '?' },
  { name: 'call', operation: ':' },
  { name: 'exit', operation: 'Q' },
]
